// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__ZUBNR","icon":"SortAdornment_icon__3V0pk","up":"SortAdornment_up__3FDPy","down":"SortAdornment_down__3elcW","active":"SortAdornment_active__3rw33"};